import React, { useMemo } from "react";
import { useLocation, Link as RouterLink } from "react-router-dom";
import { Alert, Box, Link, Typography } from "@mui/material";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import useServerTable from '../libs/useServerTable';
import NavStruct from "../components/NavStruct";

function formatSec(sec) {
    const total = Math.max(0, Math.floor(Number(sec) || 0));
    const hh = String(Math.floor(total / 3600)).padStart(2, "0");
    const mm = String(Math.floor((total % 3600) / 60)).padStart(2, "0");
    const ss = String(total % 60).padStart(2, "0");
    return `${hh}:${mm}:${ss}`;
}

export default function ScreencastTextLog() {
    const location = useLocation();
    const token = useMemo(() => location.pathname.split("/").at(-1), [location.pathname]);
    const table = useServerTable('ocr', { session: token }, {}, 'startSec', 'asc');
    const columns = [
        { dataField: 'startSec', text: 'Интервал', sort: true, formatter: (_, row) => `${formatSec(row.startSec)} - ${formatSec(row.endSec)}` },
        { dataField: 'text', text: 'Текст', sort: true, filter: textFilter({ placeholder: 'Поиск по тексту...' }) }
    ];

    return (
        <Box sx={{ padding: "0 50px 30px 50px" }}>
            <Box sx={{ margin: "20px 0" }}>
                <NavStruct />
            </Box>
            <Box sx={{ marginBottom: "12px" }}>
                <Link component={RouterLink} to="/table/other">Назад к таблице</Link>
            </Box>
            <Typography variant="h5" sx={{ marginBottom: "12px" }}>
                OCR лог скринкаста
            </Typography>
            <Typography variant="body2" sx={{ marginBottom: "16px" }}>
                Сессия: {token}
            </Typography>

            {table.error && <Alert severity="error">{table.error} <button onClick={table.reload}>Повторить</button></Alert>}
            {table.loading && <p role="status">Загрузка...</p>}

            <BootstrapTable keyField="_id" data={table.rows} columns={columns} filter={filterFactory()}
                remote={{ pagination: true, filter: true, sort: true }} onTableChange={table.onTableChange}
                defaultSorted={[{ dataField: 'startSec', order: 'asc' }]}
                noDataIndication="Нет OCR-данных для этой сессии."
                pagination={paginationFactory({ page: table.page, sizePerPage: table.limit, totalSize: table.total, sizePerPageList: [10, 25, 50, 100], showTotal: true })}/>

        </Box>
    );
}
